import { Check } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button, ScrollReveal, SpotlightCard, StatusPill } from '@agenda-facil/ui';

const plans = [
  { name: 'Solo', price: '29', description: 'Para quem atende sozinho.', features: ['1 profissional', 'Agenda online', 'Clientes e serviços', 'Página pública'], featured: false },
  { name: 'Essencial', price: '49', description: 'Para a barbearia em crescimento.', features: ['Até 3 profissionais', 'Caixa completo', 'Relatórios', 'Suporte prioritário'], featured: true },
  { name: 'Equipe', price: '89', description: 'Para operações mais movimentadas.', features: ['Até 8 profissionais', 'Permissões de equipe', 'Métricas avançadas', 'Anúncios internos'], featured: false },
] as const;

export function PlansPage() {
  return (
    <>
      <section className="marketing-grid py-20 text-center sm:py-28">
        <ScrollReveal variant="fade-up">
          <span className="eyebrow">Planos transparentes</span>
          <h1 className="display text-balance mx-auto mt-6 max-w-3xl text-5xl sm:text-7xl">
            Escolha o tamanho de hoje. Cresça amanhã.
          </h1>
          <p className="mx-auto mt-6 max-w-xl text-[var(--muted-foreground)]">
            14 dias grátis em qualquer plano. Sem cartão e sem taxa de implantação.
          </p>
        </ScrollReveal>
      </section>
      <section className="pb-20 sm:pb-28">
        <div className="page-shell grid items-stretch gap-5 lg:grid-cols-3">
          {plans.map((plan, index) => (
            <ScrollReveal key={plan.name} variant="scale" delay={(index + 1) * 120}>
              <SpotlightCard
                className={`relative h-full p-7 sm:p-9 ${plan.featured ? 'border-[var(--brand)] ring-2 ring-[var(--brand)] lg:-translate-y-4' : ''}`}
              >
                {plan.featured && (
                  <StatusPill tone="success" className="absolute right-6 top-6">
                    Mais escolhido
                  </StatusPill>
                )}
                <p className="text-lg font-extrabold">{plan.name}</p>
                <p className="mt-2 text-sm text-[var(--muted-foreground)]">{plan.description}</p>
                <div className="mt-8">
                  <span className="fraunces-num text-5xl">R$ {plan.price}</span>
                  <span className="text-sm text-[var(--muted-foreground)]"> / mês</span>
                </div>
                <ul className="mt-8 grid gap-4">
                  {plan.features.map((feature) => (
                    <li key={feature} className="flex gap-3 text-sm font-bold group/item">
                      <Check size={17} className="text-[var(--success)] transition-transform duration-200 group-hover/item:scale-125" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Button
                  className="mt-9 w-full"
                  variant={plan.featured ? 'primary' : 'secondary'}
                  asChild
                >
                  <Link to="/cadastro">Testar este plano</Link>
                </Button>
              </SpotlightCard>
            </ScrollReveal>
          ))}
        </div>
      </section>
    </>
  );
}

